export const LEARN_MESSAGES = {
    loading: "در حال دریافت محتوای دوره...",
    failed: "خطا در دریافت ساختار دوره",
    buyCourse: "خرید دوره",
    backToCourses: "بازگشت به دوره‌های من",
    credit: "اعتبار",
    streak: "روزهای متوالی",
    xp: "امتیاز",
    energy: "انرژی"
};

export const BLOCK_MESSAGES = {
    check: "بررسی",
    correct: "درست است!",
    wrong: "پاسخ اشتباه است.",

    placeholderCorrect: "پاسخ شما درست است.",
    placeholderWrong: "بعضی از پاسخ‌ها اشتباه هستند.",
    retry: "تلاش دوباره",
    removeLast: "حذف آخرین",
    clearAll: "پاک کردن همه",

    run: "اجرا",
    running: "در حال اجرا...",
    noOutput: "بدون خروجی.",
    runFailed: "اجرای کد انجام نشد.",
    runTimeout: "اجرای کد بیش از حد طول کشید.",
    loginRequired: "برای اجرای کد باید وارد شوید.",
    editable: "قابل ویرایش",
    copy: "کپی"
};

export const PROJECT_MESSAGES = {
    instructions: "دستورالعمل",
    step: "مرحله",
    nextStep: "مرحله بعد",
    hintsShow: "نمایش راهنمایی",
    hintsHide: "پنهان کردن راهنمایی",
    explanation: "توضیح",
    noSteps: "مراحل پروژه هنوز تعریف نشده‌اند.",
    projectSteps: "مراحل پروژه",
    allStepsDone: "همه‌ی مرحله‌ها را کامل کردی!",
    finishProject: "پایان پروژه",
    preview: "پیش‌نمایش",
    previewTitle: "پیش‌نمایش صفحه",
    sqlPlaceholder: "نتیجه‌ی پرسش اینجا نمایش داده می‌شود.",
    webPlaceholder: "پیام‌های اجرا اینجا نمایش داده می‌شوند.",
    emptyTable: "پرسش بدون نتیجه اجرا شد.",
    rowsLimited: (shown: number, total: number) => `${shown} ردیف از ${total} ردیف نمایش داده شد.`,
    tabCode: "کد",
    tabResult: "نتیجه",
    programInput: "ورودی برنامه",
    inputHint: "(هر خط یک ورودی)",
    inputPlaceholder: "مثال:\n10\n20",
    resultTitle: "نتیجه‌ی اجرا",
    outputPlaceholder: "خروجی اجرای برنامه اینجا نمایش داده می‌شود.",
    noOutput: "برنامه بدون خروجی اجرا شد.",

    runCode: "اجرای کد",
    running: "در حال اجرا...",
    runError: "خطا در اجرای کد",
    runFailed: "اجرای برنامه با خطا مواجه شد",
    runTimeout: "زمان اجرای برنامه به پایان رسید.",
    serverError: "خطا در ارتباط با سرور",
    loginRequired: "برای اجرای کد باید وارد شوید.",

    backToCourse: "بازگشت به دوره"
};

export const LESSON_MESSAGES = {
    loading: "در حال بارگذاری...",
    noContent: "محتوایی برای نمایش وجود ندارد.",
    outOfEnergy: "انرژی‌ات تمام شد. بعد از شارژ شدن دوباره تلاش کن.",
    back: "بازگشت",
    backToCourse: "بازگشت به دوره",
    startFailed: "شروع درس انجام نشد. لطفاً دوباره تلاش کنید.",
    videoSoon: "ویدیو به‌زودی اضافه می‌شود.",
    unsupported: "نوع محتوا پشتیبانی نمی‌شود.",

    previous: "قبلی",
    next: "بعدی",
    finishLesson: "پایان درس",

    lessonComplete: "درس تکمیل شد!",
    rewardsText: "آفرین! یک قدم دیگر به هدفت نزدیک‌تر شدی.",
    noRewardsText: "این درس را قبلاً تکمیل کرده بودی، پس جایزه‌ای ثبت نشد.",
    credit: "اعتبار",
    xp: "امتیاز تجربه (XP)",
    continue: "ادامه",

    streakDays: "روز پیاپی!",
    streakText: "هر روز یک درس؛ زنجیره‌ات را نشکن.",

    completeFailed: "خطا در ثبت نتیجه درس",
    contentFailed: "خطا در دریافت محتوا",
};